/** Tab names types */
export var TabNamesTypes;
(function (TabNamesTypes) {
    TabNamesTypes["MyAccount"] = "My Account";
    TabNamesTypes["Billing"] = "Billing";
    TabNamesTypes["Subscription"] = "Subscription";
})(TabNamesTypes || (TabNamesTypes = {}));
;
